import resetURLParams from 'common/utils/url/resetURLParams';

import { URL_PARAMS } from '../constants';

export const deleteURLParamBoundCountries = () => {
  resetURLParams([URL_PARAMS.boundCountries]);
}
